import { render, staticRenderFns } from "./renChe.vue?vue&type=template&id=12f8ce44&scoped=true&"
import script from "./renChe.vue?vue&type=script&lang=js&"
export * from "./renChe.vue?vue&type=script&lang=js&"
import style0 from "./renChe.vue?vue&type=style&index=0&id=12f8ce44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8ce44",
  null
  
)

export default component.exports